import React from "react";

import {
  THead,
  TrHead,
  TBody,
  Th,
  Tr,
  Td,
  InnerCell,
} from "@teamrota/rota-design";

import { EmptyText } from "~/src/components/payroll/style";
import { formatDateMonthTimeShort } from "~/src/utils/formatting";

import { ScrollableTable } from "../styles";
import { COL_WIDTHS } from ".";

interface AuditLog {
  id: number;
  userEmail: string;
  userName: string;
  action: string;
  resourceId: number;
  isError: boolean;
  message: string;
  createdAt: string;
}

interface TableProps {
  auditLogs: AuditLog[];
  loading: boolean;
}

const StatusDot = ({ isError }: { isError: boolean }) => (
  <span
    style={{
      display: "inline-block",
      width: 10,
      height: 10,
      borderRadius: "50%",
      backgroundColor: isError ? "#e74c3c" : "#2ecc71",
      marginRight: 6,
      verticalAlign: "middle"
    }}
  />
);

const Table: React.FC<TableProps> = ({ auditLogs, loading }) => {
  return (
    <ScrollableTable colWidths={COL_WIDTHS}>
      <THead>
        <TrHead>
          <Th>Time</Th>
          <Th>User</Th>
          <Th>Action</Th>
          <Th>Resource ID</Th>
          <Th>Status</Th>
          <Th>Message</Th>
        </TrHead>
      </THead>

      <TBody className="audit-table-scroll-body">
        {!loading && auditLogs?.length ? (
          auditLogs.map((log: AuditLog) => (
            <Tr key={log.id}>
              <Td>
                <InnerCell>
                  {formatDateMonthTimeShort(log.createdAt)}
                </InnerCell>
              </Td>
              <Td>
                <InnerCell>
                  {log.userName || log.userEmail}
                </InnerCell>
              </Td>
              <Td>
                <InnerCell>{log.action}</InnerCell>
              </Td>
              <Td>
                <InnerCell>{log.resourceId}</InnerCell>
              </Td>
              <Td>
                <InnerCell>
                  <StatusDot isError={log.isError} />
                  {log.isError ? "Error" : "OK"}
                </InnerCell>
              </Td>
              <Td>
                <InnerCell>{log.message}</InnerCell>
              </Td>
            </Tr>
          ))
        ) : (
          <Tr>
            <Td colSpan={6}>
              <EmptyText>
                {!loading && "No audit logs found"}
                {loading && "Loading..."}
              </EmptyText>
            </Td>
          </Tr>
        )}
      </TBody>
    </ScrollableTable>
  );
};

export default Table;
